export const DEVNET_REST_SERVICE = 'https://fullnode.devnet.aptoslabs.com'
export const DEVNET_FAUCET_SERVICE = 'https://faucet.devnet.aptoslabs.com'

export const TESTNET_REST_SERVICE = 'https://fullnode.testnet.aptoslabs.com'
export const TESTNET_FAUCET_SERVICE = 'https://faucet.testnet.aptoslabs.com'
